import React, { useCallback, useMemo, useState } from 'react';
import NotificationContext from 'shared/context/NotificationContext';
import NotificationModal from '../components/Notifications/NotificationModal';

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState(null);

  const addNotification = useCallback(
    ({
      message,
      title,
      button = null,
      buttonAction = null,
      hideCloseButton = false,
      hideHelpButton = false,
      hasCancelButton = false,
      customMessageStyle = {},
    }) =>
      setNotification({
        message,
        title,
        button,
        buttonAction,
        hideCloseButton,
        hideHelpButton,
        hasCancelButton,
        customMessageStyle,
      }),
    []
  );

  const clearNotification = useCallback(() => setNotification(null), []);

  // Memoize so consumers don't re-render on every provider render (only when the
  // notification value actually changes).
  const notificationContextValue = useMemo(
    () => ({ notification, addNotification, clearNotification }),
    [notification, addNotification, clearNotification]
  );

  return (
    <NotificationContext.Provider value={notificationContextValue}>
      {notification && <NotificationModal />}
      {children}
    </NotificationContext.Provider>
  );
};

